import { jsxs as r, jsx as l } from "react/jsx-runtime";
const c = (h) => /* @__PURE__ */ r(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...h,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M14.746 40.577V29.309h34.557v4.38c1.124.21 2.199.562 3.206 1.034v-5.416h4.604l.86-3.002h-5.48L46.93 14.829H16.66l-5.105 11.476H6.02l.86 3.002h4.66v20.05h10.242v-5.754H33.82c.268-1.065.663-2.079 1.169-3.026H14.746Zm22.729-22.745h7.389l4.107 8.473H33.474l4.001-8.473Zm-18.678 0h11.668l-4.002 8.473H15.028l3.77-8.473Z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M38.036 34.392H26.013v1.901h12.023v-1.901ZM46.83 35.76c-6.138 0-11.114 4.976-11.114 11.114 0 6.138 4.976 11.114 11.114 11.114 6.138 0 11.114-4.976 11.114-11.114 0-6.138-4.975-11.114-11.114-11.114Zm0 19.231c-4.476 0-8.117-3.641-8.117-8.117 0-4.476 3.641-8.117 8.117-8.117 4.476 0 8.117 3.641 8.117 8.117 0 4.476-3.641 8.117-8.117 8.117Z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M46.09 48.38v3.89h-2.41V41.453h4.073c2.198 0 3.708 1.45 3.708 3.464 0 2.045-1.51 3.464-3.708 3.464H46.09Zm1.42-2.075c.915 0 1.54-.534 1.54-1.374 0-.87-.625-1.388-1.54-1.388h-1.404v2.762h1.403Z"
        }
      )
    ]
  }
);
export {
  c as Parking
};
